import { useBusinessSettingsContext } from '../../hooks/useBusinessSettingsContext'
import ProductDetail from '../ProductDetail'
import FashionProductDetail from '../../storefronts/indumentaria-femenina/FashionProductDetail'

function PublicProductDetail() {
  const { activeProfile, loading } = useBusinessSettingsContext()

  if (loading && !activeProfile) {
    return null
  }

  if (activeProfile?.rubro === 'indumentaria' && (activeProfile?.subrubro || 'femenina') === 'femenina') {
    return <FashionProductDetail />
  }

  return <ProductDetail />
}

export default PublicProductDetail
